export const CTRL_MESSAGE_TRANSLATIONS_KEY: string = '$ctrl_message_translations';
